module.exports = __webpack_public_path__ + "img/oddnary_bg_login.e2edae46.jpg";